import { CircleHelp } from 'lucide-react';
import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

/**
 * En-tête de page. Son rendu dépend du style d'affichage (variables `--header-*`
 * de styles/index.css) : bandeau dégradé en « Continuité », titre sur fond de page
 * en « Marine », barre blanche en « Clarté ». Les contrôles posés dans `actions`
 * utilisent la classe `hdr-ctl` ou la variante `inverse` du bouton.
 */
export function PageHeader({
  title,
  subtitle,
  actions,
  helpTopic,
}: {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
  /** Rubrique de l'aide intégrée (id de help-content.ts) liée depuis cet en-tête. */
  helpTopic?: string;
}) {
  return (
    <header className="page-header px-4 py-6 sm:px-6 lg:px-8">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div className="min-w-0">
          <div className="flex items-center gap-3">
            <h1 className="text-2xl font-bold tracking-tight">{title}</h1>
            {helpTopic && (
              <Link
                to={`/aide#${helpTopic}`}
                className="page-header-sub inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium hover:underline"
                title="Ouvrir l’aide sur cette page"
              >
                <CircleHelp className="h-3.5 w-3.5" aria-hidden="true" />
                Aide
              </Link>
            )}
          </div>
          {subtitle && <p className="page-header-sub mt-1 text-sm">{subtitle}</p>}
        </div>
        {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
      </div>
    </header>
  );
}
